// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"resultNoteList_paginationContainer__VFC75"};